import React, {useState, useEffect, useRef} from 'react';
import {animated, useSpring} from 'react-spring';


function Number({className, color = "dark", children, bg = 'light', animate}) {
  const [state, toggle] = useState(false)
  const { x } = useSpring({ from: { x: 0 }, x: state ? 1 : 0, config: { duration: 2500 } })
  const firstRender = useRef(true);
  useEffect(() => {
      if (firstRender.current) {
          firstRender.current = false;
          return;
      }
      if (animate) {
        toggle(toggle => !toggle)
      }
  }, [children, animate])


  return (
      <animated.span 
          // onClick={() => toggle(!state)}
          className={`${bg}-bg text-${color} rounded ${className}`}
          style={{
              // opacity: x.interpolate({ range: [0, 1], output: [0.3, 1] }),
              transform: x
                  .interpolate({
                      range: [0, 0.25, 0.35, 0.45, 0.55, 0.65, 0.75, 1],
                      output: [1, 0.97, 0.9, 1.1, 0.9, 1.1, 1.03, 1]
                  })
                  .interpolate(x => `scale(${x})`)
          }}
      >
          {children}
      </animated.span>
  )
}

export default Number;